<pk-navigation-bar *ngIf="showConfigureNavigation"></pk-navigation-bar>
<pk-navigation-bar-poker *ngIf="!showConfigureNavigation"></pk-navigation-bar-poker>
<vn-page-matrix path="App-v1.0/partials/notfound"></vn-page-matrix>
